import { useEffect, useRef } from 'react';

export default function VisualShowcase() {
  const itemsRef = useRef<(HTMLDivElement | null)[]>([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add('visible');
        });
      },
      { threshold: 0.1 }
    );
    itemsRef.current.forEach((el) => { if (el) observer.observe(el); });
    return () => observer.disconnect();
  }, []);

  return (
    <section
      id="section-showcase"
      data-section="Visual Showcase"
      className="w-full bg-[#0A0A0A] pt-4 pb-0 overflow-hidden"
      style={{ borderTop: '1px solid rgba(255,255,255,0.06)' }}
    >
      <div className="w-full px-8 md:px-16">

        {/* Section label */}
        <div
          ref={(el) => { itemsRef.current[0] = el; }}
          className="reveal flex items-center gap-4 mb-10"
        >
          <div className="w-6 h-px bg-white/25" />
          <span className="font-display text-[9px] tracking-[0.5em] uppercase text-white/35">
            Signature Visuals
          </span>
        </div>

        {/* Full-width cinematic grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-3">

          {/* Large left — tall portrait */}
          <div
            ref={(el) => { itemsRef.current[1] = el; }}
            className="reveal reveal-delay-1 md:col-span-1 group relative overflow-hidden h-[300px] sm:h-[420px] md:h-[560px]"
          >
            <img
              src="https://public.readdy.ai/ai/img_res/edited_77dc730b7c88d057524a74a6f3917f82_355216fc.jpg"
              alt="Urban Blings Signature Chain"
              className="w-full h-full object-cover object-center group-hover:scale-[1.04] transition-transform duration-1000"
            />
            <div className="absolute bottom-6 left-6">
              <span className="font-display text-[9px] tracking-[0.4em] uppercase text-white/50">Chain Series</span>
            </div>
          </div>

          {/* Right column stacked */}
          <div className="md:col-span-2 flex flex-col gap-3">

            {/* Top wide — urban neon street */}
            <div
              ref={(el) => { itemsRef.current[2] = el; }}
              className="reveal reveal-delay-2 group relative overflow-hidden h-[200px] sm:h-[240px] md:h-[270px]"
            >
              <img
                src="https://static.readdy.ai/image/6a30e07b0f7694c83ca4df4a3a91c3d2/a0c039fe29d7bd64d5b8ff33b8ebfc41.png"
                alt="Urban Night Aesthetic"
                className="w-full h-full object-cover object-center group-hover:scale-[1.04] transition-transform duration-1000"
                style={{ transform: 'scale(1.12) translate(-2%, -2%)', transformOrigin: 'center center' }}
              />
              <div className="absolute inset-0 bg-gradient-to-b from-transparent to-black/50" />
              <div className="absolute bottom-6 right-6">
                <span className="font-display text-[9px] tracking-[0.4em] uppercase text-white/50">Night Aesthetic</span>
              </div>
            </div>

            {/* Bottom wide — jewelry detail */}
            <div
              ref={(el) => { itemsRef.current[3] = el; }}
              className="reveal reveal-delay-3 group relative overflow-hidden h-[200px] sm:h-[240px] md:h-[270px]"
            >
              <img
                src="https://public.readdy.ai/ai/img_res/4f37c80d6da6ae8f12e1ae09dd58df11.jpg"
                alt="Urban Blings Jewelry Detail"
                className="w-full h-full object-cover object-center group-hover:scale-[1.04] transition-transform duration-1000"
              />
              <div className="absolute inset-0 bg-gradient-to-b from-transparent to-black/50" />
              <div className="absolute bottom-6 right-6">
                <span className="font-display text-[9px] tracking-[0.4em] uppercase text-white/50">FURY OF SILENCE</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
